import { render, staticRenderFns } from "./GameDetailsNew.vue?vue&type=template&id=a075460a&scoped=true"
import script from "./GameDetailsNew.vue?vue&type=script&lang=js"
export * from "./GameDetailsNew.vue?vue&type=script&lang=js"
import style0 from "./GameDetailsNew.vue?vue&type=style&index=0&id=a075460a&prod&lang=scss&module=true"
import style1 from "./GameDetailsNew.vue?vue&type=style&index=1&id=a075460a&prod&scoped=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "a075460a",
  null
  
)

export default component.exports